if (!customElements.get('recently-viewed-products')) {
  customElements.define(
    'recently-viewed-products',
    class RecentlyViewedProducts extends HTMLElement {
      connectedCallback() {
        if (this.loadState === 'loaded' || this.loadState === 'loading') return;
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.observer.disconnect();
              this.init();
            }
          }, {rootMargin:'400px'});
          this.observer.observe(this.closest('.shopify-section') || this);
        } else this.init();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        if (this.loadState === 'loading') this.loadState = 'idle';
      }

      init() {
        if (!this.isConnected || this.loadState === 'loading' || this.loadState === 'loaded') return;
        this.loadState = 'loading';
        const controller = new AbortController();
        this.controller = controller;
        const queryUrl = this.getQueryUrl();
        if (!queryUrl) {
          this.removeSection();
          return;
        }

        fetch(queryUrl, {signal:controller.signal})
          .then((response) => { if (!response.ok) throw new Error('Recommendation request failed'); return response.text(); })
          .then((responseText) => {
            if (!this.isConnected || controller.signal.aborted) return;
            this.loadState = 'loaded';
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('recently-viewed-products');
            if (recommendations && recommendations.innerHTML.trim().length) {
              const section = recommendations.querySelector('.section');
              section?.classList.remove('hidden');

              this.innerHTML = recommendations.innerHTML;
            }

            if (recommendations?.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              this.removeSection();
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            if (controller.signal.aborted) return;
            this.loadState = 'idle';
            console.error(e);
          });
      }

      getQueryUrl() {
        let stored;
        try { stored = JSON.parse(window.localStorage.getItem('hypertheme:recently-viewed') || '[]'); } catch { return false; }
        if (!Array.isArray(stored)) return false;
        const items = [...new Set(stored.map(Number).filter(id => Number.isSafeInteger(id) && id > 0))];
        const productId = parseInt(this.dataset.productId);
        const productsToShow = parseInt(this.dataset.productsToShow);

        if (items.includes(productId)) {
          items.splice(items.indexOf(productId), 1);
        }

        if (items.length > 0) {
          const queryParams = items
            .map((item) => 'id:' + item)
            .slice(0, productsToShow)
            .join(' OR ');

          return this.dataset.url + queryParams;
        }

        return false;
      }

      removeSection() {
        this.remove();
      }

      sendTrekkieEvent(numberProducts) {
        if (!window.ShopifyAnalytics || !window.ShopifyAnalytics.lib || !window.ShopifyAnalytics.lib.track) {
          return;
        }
        let didPageJumpOccur = this.getBoundingClientRect().top <= window.innerHeight;

        window.ShopifyAnalytics.lib.track('Recently Viewed Products Displayed', {
          theme: Shopify.theme.name,
          didPageJumpOccur: didPageJumpOccur,
          numberOfRecommendationsDisplayed: numberProducts,
        });
      }
    }
  );
}
